import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { NA_VALUE } from '../../constants';
import { UseFormBuilderPropsT } from './types';

const useFormBuilder = (props: UseFormBuilderPropsT) => {
	const {
		data,
		mode,
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader,
		fieldConfig,
		layoutConfig,
		validationSchema,
		hidePopUp = false
	} = props;
	const [alert, setAlert] = useState<{ show: boolean; message: string }>({ show: false, message: '' });
	const [submittedData, setSubmittedData] = useState({});

	const {
		control,
		handleSubmit,
		formState: { errors },
		watch,
		setValue
	} = useForm({
		defaultValues: data,
		resolver: yupResolver(validationSchema || yup.object(), { initialValues: data })
	});

	const customSubmitHandler = (submitData: any) => {
		setSubmittedData(submitData);

		const getMessage = () => {
			if (submitData.deleteCronJob) {
				return 'Do you really want to delete the existing scheduled segment?';
			}

			const hasValidSchedule = submitData.scheduledAtTimestamp && submitData.scheduledAtTimestamp !== NA_VALUE;

			if (hasValidSchedule) {
				return `Segment is already scheduled at ${submitData.scheduledAtTimestamp}. Do you want to overwrite the scheduling?`;
			}

			return 'Please verify the changes before submission';
		};

		setAlert({ show: true, message: getMessage() });
	};

	const onSubmit = (submitData: any) => {
		if (!hidePopUp) {
			customSubmitHandler(submitData);
		} else {
			handleFormSubmit(submitData);
		}
	};

	const handleCancelClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		handleFormCancel();
		event.preventDefault();
	};

	const handleAlertConfirmation = async () => {
		handleFormSubmit(submittedData);
		setAlert({ show: false, message: '' });
	};

	const handleAlertCancel = () => {
		setAlert({ show: false, message: '' });
	};

	return {
		fieldConfig,
		layoutConfig,
		alert,
		control,
		errors,
		mode,
		showLoader,
		watch,
		onSubmit,
		handleSubmit,
		handleCancelClick,
		handleAlertConfirmation,
		handleAlertCancel,
		setShowLoader,
		setValue,
		initialValues: data
	};
};

export default useFormBuilder;
